import request from './api';
import { API_LAST_MINUTE } from '../constants/api';

export const getLastMinutes = (size, page) =>
  request(`${API_LAST_MINUTE}?size=${size}&page=${page}`, {
    method: 'GET'
  });
